import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { IndeedFlexCompaniesProvider } from './context/IndeedFlexCompaniesProvider'
import { IndeedFlexCompaniesWorkflowsProvider } from './context/IndeedFlexCompaniesWorkflowsProvider'
import { IndeedFlexCompaniesMain } from './components/IndeedFlexCompaniesMain'
import { CreateIndeedFlexCompanyFlow } from './workflows/CreateIndeedFlexCompanyFlow'
import { EditIndeedFlexCompanyFlow } from './workflows/EditIndeedFlexCompanyFlow'

export const IndeedFlexCompanies = () => {
  return (
    <NuqsAdapter>
      <IndeedFlexCompaniesProvider>
        <IndeedFlexCompaniesWorkflowsProvider>
          <IndeedFlexCompaniesMain />
          <CreateIndeedFlexCompanyFlow />
          <EditIndeedFlexCompanyFlow />
        </IndeedFlexCompaniesWorkflowsProvider>
      </IndeedFlexCompaniesProvider>
    </NuqsAdapter>
  )
}
